(() => {
  const finePointer = () => window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  const closeItem = (item) => {
    item.classList.remove('is-open');
    const trigger = item.querySelector(':scope > [aria-haspopup="true"]');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');

    for (const branch of item.querySelectorAll('.shop-aisle-nav__branch.is-open')) {
      branch.classList.remove('is-open');
      const branchTrigger = branch.querySelector(':scope > [aria-haspopup="true"]');
      if (branchTrigger) branchTrigger.setAttribute('aria-expanded', 'false');
    }
  };

  const closeAll = (nav, exceptItem) => {
    for (const item of nav.querySelectorAll('.shop-aisle-nav__item.is-open')) {
      if (item === exceptItem) continue;
      closeItem(item);
    }
  };

  const bindNav = (nav) => {
    nav.addEventListener('click', (event) => {
      const branchTrigger = event.target.closest('.shop-aisle-nav__branch > [aria-haspopup="true"]');
      if (branchTrigger) {
        event.preventDefault();
        const branch = branchTrigger.closest('.shop-aisle-nav__branch');
        const open = branch.classList.contains('is-open');
        const item = branch.closest('.shop-aisle-nav__item');

        for (const other of item.querySelectorAll('.shop-aisle-nav__branch.is-open')) {
          if (other === branch) continue;
          other.classList.remove('is-open');
          const otherTrigger = other.querySelector(':scope > [aria-haspopup="true"]');
          if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
        }

        branch.classList.toggle('is-open', !open);
        branchTrigger.setAttribute('aria-expanded', open ? 'false' : 'true');
        return;
      }

      const parent = event.target.closest('.shop-aisle-nav__parent');
      if (!parent || !nav.contains(parent)) return;

      event.preventDefault();
      const item = parent.closest('.shop-aisle-nav__item');
      const open = item.classList.contains('is-open');
      closeAll(nav, item);

      if (open) {
        closeItem(item);
        return;
      }

      item.classList.add('is-open');
      parent.setAttribute('aria-expanded', 'true');
    });

    nav.addEventListener('pointerenter', (event) => {
      if (!finePointer()) return;
      const item = event.target.closest('.shop-aisle-nav__item');
      if (!item || !nav.contains(item)) return;
      const parent = item.querySelector(':scope > .shop-aisle-nav__parent');
      if (parent) parent.setAttribute('aria-expanded', 'true');
    }, true);

    nav.addEventListener('pointerleave', (event) => {
      if (!finePointer()) return;
      const item = event.target.closest('.shop-aisle-nav__item');
      if (!item || !nav.contains(item)) return;
      if (item.classList.contains('is-open')) return;
      const parent = item.querySelector(':scope > .shop-aisle-nav__parent');
      if (parent) parent.setAttribute('aria-expanded', 'false');
    }, true);
  };

  const start = () => {
    const navs = document.querySelectorAll('[data-shop-aisle-menus]');
    for (const nav of navs) {
      bindNav(nav);
    }

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;

      for (const nav of document.querySelectorAll('[data-shop-aisle-menus]')) {
        const openItems = nav.querySelectorAll('.shop-aisle-nav__item.is-open');
        let focusTarget = null;

        for (const item of openItems) {
          if (!focusTarget) {
            focusTarget = item.querySelector(':scope > .shop-aisle-nav__parent');
          }
          closeItem(item);
        }

        if (focusTarget) focusTarget.focus();
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
